<template lang="pug">
	.editEmployeeContainer
		form(@submit.prevent="employeeFormSubmitted")
			.modal-card: .modal-card-body
				b-field(label="Department", :type="{'is-danger': orgErrors.length }", :message="orgErrors")
					b-select(v-model="employee.org", :disabled="isLoading || currentEmployee !== null || userOrgs.length < 2")
						option(v-for="org in userOrgs", :key="org", :value="org") {{ org }}
				b-field(label="ID", :type="{'is-danger': tagErrors.length }", :message="tagErrors")
					b-input(v-model="employee.tag", type="text", placeholder="", :disabled="isLoading || currentEmployee !== null")
				b-field(label="Name (Optional)", :type="{'is-danger': nameErrors.length }", :message="nameErrors")
					b-input(v-model="employee.name", type="text", placeholder="", :disabled="isLoading")
				b-field(label="Notes (Optional)", :type="{'is-danger': notesErrors.length }", :message="notesErrors")
					b-input(v-model="employee.notes", type="text", placeholder="", :disabled="isLoading")
				b-field(label="Email (Optional)", :type="{'is-danger': emailErrors.length }", :message="emailErrors")
					b-input(v-model="employee.email", type="text", placeholder="", :disabled="isLoading")
				p.spacer
				b-field
					p.control
				.level
					.level-left
						.level-item
							template(v-if="!currentEmployee")
								//- Adding a new employee
								input.button.is-primary(type="submit", name="submit", value="Add", :disabled="isLoading")
							template(v-else)
								//- Editing an existing employee
								input.button.is-primary(type="submit", name="submit", value="Update", :disabled="isLoading")
						.level-item
							template(v-if="!currentEmployee")
								//- Adding a new employee
								button.button.is-light(@click.prevent="clearForm", :disabled="isLoading") Clear
					.level-right
						.level-item: button.button.is-dark(@click.prevent="$parent.close()") Close
		
</template>

<style lang="scss" scoped>
	.modal-card-body {
		border-radius: 6px;
	}
</style>

<script>
	import { mapGetters } from "vuex";

	export default {
		props: ["currentEmployee"], // if editing an existing employee, prefill form fields
		data() {
			return {
				isLoading: false,
				employee: this.currentEmployee || this.generateBlankEmployee(), // the form's model
				errors: [],
				serverErrors: []
			};
		},
		computed: {
			...mapGetters(["userOrgs"]),
			orgErrors() {
				return this.errors.filter((el) => el.toLowerCase().indexOf("org") > -1).join(" ");
			},
			tagErrors() {
				return this.errors.filter((el) => el.toLowerCase().indexOf("id") > -1).join(" ");
			},
			nameErrors() {
				return this.errors.filter((el) => el.toLowerCase().indexOf("name") > -1).join(" ");
			},
			notesErrors() {
				return this.errors.filter((el) => el.toLowerCase().indexOf("notes") > -1).join(" ");
			},
			emailErrors() {
				return this.errors.filter((el) => el.toLowerCase().indexOf("email") > -1).join(" ");
			},
			internalErrors() {
				return this.errors.filter((el) => el.toLowerCase().indexOf("unknown error") > -1).join(" ");
			}
		},
		methods: {
			generateBlankEmployee() {
				return {
					org: this.userOrgs ? this.userOrgs[0] : "",
					tag: "",
					name: "",
					notes: "",
					email: ""
				};
			},
			clearForm(keepOrg) {
				this.employee = this.generateBlankEmployee();
				if (keepOrg) this.employee.org = keepOrg;
				this.errors = [];
				this.serverErrors = [];
			},
			employeeFormSubmitted() {
				// Prevent user input
				this.isLoading = true;
				let loadingComponent = this.$buefy.loading.open();

				this.$store
					.dispatch("editEmployee", {
						action: this.currentEmployee ? "edit" : "add",
						// employerID: this.$store.state.user._id,
						org: this.employee.org,
						employeeID: this.currentEmployee ? this.employee._id : "",
						tag: this.employee.tag,
						name: this.employee.name,
						notes: this.employee.notes,
						email: this.employee.email
					})
					.then(() => {
						// Show Success Notification
						this.$buefy.snackbar.open({
							duration: 3000,
							message: this.currentEmployee ? "Updated successfully." : "Added successfully.",
							type: "is-success",
							position: "is-top-right",
							queue: false
						});

						loadingComponent.close();
						this.isLoading = false;
						if (this.currentEmployee) {
							// Editing -- close modal after finished
							this.$parent.close();
						} else {
							// Adding -- clear record for next measurement, keep modal open
							this.clearForm(this.employee.org);
						}
					})
					.catch((errData) => {
						// DEMO
						if (errData === "DEMO: Cannot edit this demo user.") {
							this.$buefy.snackbar.open({
								duration: 3000,
								message: errData,
								type: "is-warning",
								position: "is-top-right",
								queue: false
							});
							loadingComponent.close();
							this.isLoading = false;
							return;
						}

						console.log(errData);
						// Errors, i.e. user did not fill out all fields
						this.errors = errData.userErrors || [];
						this.serverErrors = errData.serverErrors;

						if (this.internalErrors.length) {
							this.$buefy.snackbar.open({
								duration: 3000,
								message: this.internalErrors,
								type: "is-danger",
								position: "is-top-right",
								queue: false
							});
						}
						loadingComponent.close();
						this.isLoading = false;
					});
			}
		},
		mounted() {
			// Default the selected organization to the correct organization or the first in the list of organizations
			this.employee.org = this.currentEmployee ? this.currentEmployee.org : this.userOrgs[0];
		}
	};
</script>
